import { Button, Flex, Form, Input, Modal, notification, Switch } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { addHobby } from '../../../api/customerHobby/customerHobbyApi'
import { FormProps } from 'antd/lib'
import { useForm } from 'antd/es/form/Form'

interface Props {
  show: boolean
  modalClose?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
}

const AddHobbyModal: React.FC<Props> = (props) => {
  const { show, modalClose, onSubmitFormModal } = props
  const [code, setCode] = useState("")
  const [title, setTitle] = useState("")
  const [status, setStatus] = useState(0)

  const formRef: any = useRef(null)
  const [form] = useForm()


  const onFormFinish = async () => {
    const result = await addHobby(code, title, status)
    if (result?.status) {
      onSubmitFormModal?.(true)
    } else {
      onSubmitFormModal?.(false, result.message)
    }
  }
  useEffect(() => {
    if (show) {

    } else {
      setTitle("")
      setStatus(0)
      if (form)
        form.resetFields()
    }

  }, [show])


  return (
    <>
      <Modal
        open={show}
        title='Tạo sở thích'
        className='rs-modal w-400 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form
          ref={formRef}
          form={form}
          className='rs-form add-relative-form'
          onFinish={onFormFinish}
          requiredMark={false}
        >
          <Form.Item
            layout='vertical'
            label='Mã sở thích'
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập mã sở thích" }
            ]}
          >
            <Input
              placeholder='Mã sở thích'
              className='rs-input rs-input--32'
              maxLength={8}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            layout='vertical'
            label='Tên sở thích'
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập tên sở thích" }
            ]}
          >
            <Input
              placeholder='Tên sở thích'
              className='rs-input rs-input--32'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Item>

          <Form.Item name='status'>
            <Flex className='gap-24px'>
              <span>Sử dụng</span>
              <Switch
                checked={!!status}
                onChange={(checked) => setStatus(checked ? 1 : 0)}
                className="rs-switch"
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default AddHobbyModal
